import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { BtnOutlineGreen } from '../../styled-components';
import _ from 'lodash';
import {
  ContractEONType,
  DataTable,
  DateTimeField,
  Field,
} from '../../commons/DataTable';

function ContractsHistoryModal({ toggle, isOpen, data = [] }) {
  const [t] = useTranslation('CONTRACTS');

  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ maxWidth: '80%' }}>
      <ModalHeader toggle={toggle}>
        {t('CONTRACTS_HISTORY_MODAL_TITLE')}
      </ModalHeader>

      <ModalBody>
        <DataTable
          data={data}
          //   total={total}
          //   offset={offset}
          //   limit={limit}
          emptyText={t('COMMON:NO_DATA')}
        >
          <Field
            title="Nome Fornitore"
            source="supplier.businessName"
            className="text-left"
          />
          <Field title="Partita iva fornitore" source="supplier.taxCode" />
          <ContractEONType title="Nome prodotto" source="product_name" />
          <DateTimeField
            title="Data inizio"
            source="startDate"
            format="DD/MM/YYYY"
          />
          <DateTimeField
            title="Data Fine"
            source="endDate"
            format="DD/MM/YYYY"
          />
        </DataTable>
      </ModalBody>
      <ModalFooter>
        <BtnOutlineGreen type="button" className="uppercase" onClick={toggle}>
          {t('COMMON:CLOSE')}
        </BtnOutlineGreen>
      </ModalFooter>
    </Modal>
  );
}

export default ContractsHistoryModal;
